import { Button, Flex, Text } from '@chakra-ui/react'
import { PROJECT_ACCOUNTING_APPROVAL, PROJECT_ARTWORK, PROJECT_CLIENT_VOLTAGE, PROJECT_CRATING_STATUS, PROJECT_DEPOSIT_STATUS, PROJECT_FABREND, PROJECT_FLIGHT_CHECK, PROJECT_INVOICE_STATUS, PROJECT_PERMIT, PROJECT_POST_INSTALL_CALL, PROJECT_STAGES, ROLES } from 'lib'
import { format as formatDate } from 'date-fns'

export const ALL_PROJECTS_FILTER_FIELDS = ['customerState', 'stage']
export const ALL_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Customer Name',
    orderBy: 'customerName',
    render: ({ customerName }) => customerName
  },
  {
    label: 'City',
    orderBy: 'customerCity',
    render: ({ customerCity }) => customerCity
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState,
    toggleable: true
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  // {
  //   label: 'Deposit',
  //   orderBy: 'depositStatus',
  //   render: ({ depositStatus }) => {
  //     switch (depositStatus) {
  //       case PROJECT_DEPOSIT_STATUS.POReceived:
  //       case PROJECT_DEPOSIT_STATUS.POAndPaymentReceived:
  //       case PROJECT_DEPOSIT_STATUS.PaymentReceived:
  //         return <Text color='green'>{depositStatus}</Text>
  //       case PROJECT_DEPOSIT_STATUS.NotReceived:
  //         return <Text color='red'>{depositStatus}</Text>
  //       default:
  //         return depositStatus
  //     }
  //   }
  // },
  // {
  //   label: 'Permit',
  //   orderBy: 'permit',
  //   render: ({ permit }) => {
  //     switch (permit) {
  //       case PROJECT_PERMIT.Approved:
  //       case PROJECT_PERMIT.ClientInstall:
  //       case PROJECT_PERMIT.NotNeeded:
  //         return <Text color='green'>{permit}</Text>
  //       case PROJECT_PERMIT.NotYetDetermined:
  //         return <Text color='red'>{permit}</Text>
  //       default:
  //         return permit
  //     }
  //   }
  // },
  {
    label: 'Stage',
    orderBy: 'stage',
    render: ({ stage }) => {
      switch (stage) {
        case PROJECT_STAGES.Cancelled:
          return <Text color='red'>{stage}</Text>
        case PROJECT_STAGES.Complete:
          return <Text color='green'>{stage}</Text>
        default:
          return stage
      }
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const STAGING_PROJECTS_FILTER_FIELDS = ['flightCheck', 'depositStatus']
export const STAGING_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Days Since Order',
    orderBy: 'daysSinceOrder',
    render: ({ daysSinceOrder }) => daysSinceOrder
  },
  {
    label: 'Pre-Pro Conference',
    orderBy: 'flightCheck',
    render: ({ flightCheck }) => {
      switch (flightCheck) {
        case PROJECT_FLIGHT_CHECK.Completed:
          return <Text color='green'>{flightCheck}</Text>
        case PROJECT_FLIGHT_CHECK.NotYetScheduled:
          return <Text color='red'>{flightCheck}</Text>
        default:
          return flightCheck
      }
    }
  },
  {
    label: 'Deposit',
    orderBy: 'depositStatus',
    render: ({ depositStatus }) => {
      switch (depositStatus) {
        case PROJECT_DEPOSIT_STATUS.POReceived:
        case PROJECT_DEPOSIT_STATUS.POAndPaymentReceived:
        case PROJECT_DEPOSIT_STATUS.PaymentReceived:
          return <Text color='green'>{depositStatus}</Text>
        case PROJECT_DEPOSIT_STATUS.NotReceived:
          return <Text color='red'>{depositStatus}</Text>
        default:
          return depositStatus
      }
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const PRE_PRODUCTION_PROJECTS_FILTER_FIELDS = ['clientVoltage', 'siteSurvey', 'permit', 'artwork', 'fabRend']
export const PRE_PRODUCTION_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Days Since Order',
    orderBy: 'daysSinceOrder',
    render: ({ daysSinceOrder }) => daysSinceOrder
  },
  {
    label: 'Client\'s Voltage',
    orderBy: 'clientVoltage',
    render: ({ clientVoltage }) => {
      const _clientVoltage = clientVoltage || 'Not Yet Determined'
      switch (_clientVoltage) {
        case PROJECT_CLIENT_VOLTAGE.NotRequired:
          return <Text color='green'>{_clientVoltage}</Text>
        case PROJECT_CLIENT_VOLTAGE.NotYetDetermined:
          return <Text color='red'>{_clientVoltage}</Text>
        default:
          return _clientVoltage
      }
    }
  },
  {
    label: 'Site Survey',
    orderBy: 'siteSurvey',
    render: ({ siteSurvey, isObtainAndReviewSurveyTaskCompleted }) => {
      switch (siteSurvey) {
        case 'Not Required':
          return <Text color='green'>{siteSurvey}</Text>
        case 'Not Needed':
          return <Text color='green'>{siteSurvey}</Text>
        default:
          return isObtainAndReviewSurveyTaskCompleted ? <Text color='green'>{siteSurvey}</Text> : <Text color='red'>{siteSurvey}</Text>
      }
    }
  },
  {
    label: 'Permit',
    orderBy: 'permit',
    render: ({ permit }) => {
      switch (permit) {
        case PROJECT_PERMIT.NotNeeded:
        case PROJECT_PERMIT.Approved:
        case PROJECT_PERMIT.ClientInstall:
          return <Text color='green'>{permit}</Text>
        case PROJECT_PERMIT.NotYetDetermined:
          return <Text color='red'>{permit}</Text>
        default:
          return permit
      }
    }
  },
  {
    label: 'Artwork',
    orderBy: 'artwork',
    render: ({ artwork }) => {
      switch (artwork) {
        case PROJECT_ARTWORK.Approved:
        case PROJECT_ARTWORK.NotNeeded:
          return <Text color='green'>{artwork}</Text>
        case PROJECT_ARTWORK.NotYetDetermined:
          return <Text color='red'>{artwork}</Text>
        default:
          return artwork
      }
    }
  },
  {
    label: 'Job Packet',
    orderBy: 'fabRend',
    render: ({ fabRend }) => {
      switch (fabRend) {
        case PROJECT_FABREND.Completed:
        case PROJECT_FABREND.NotNeeded:
          return <Text color='green'>{fabRend}</Text>
        case PROJECT_FABREND.Incomplete:
          return <Text color='red'>{fabRend}</Text>
        default:
          return fabRend
      }
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const PRODUCTION_PROJECTS_FILTER_FIELDS = ['emcVendor', 'fabVendor', 'installer', 'steelVendor']
export const PRODUCTION_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Days in Production',
    orderBy: 'daysInProduction',
    render: ({ daysInProduction }) => daysInProduction
  },
  {
    label: 'Emc Vendor',
    orderBy: 'emcVendor',
    render: ({ emcVendor }) => {
      const _emcVendor = emcVendor || 'Not Yet Determined'
      switch (_emcVendor) {
        case 'Not Required':
          return <Text color='green'>{_emcVendor}</Text>
        case 'Not Yet Determined':
          return <Text color='red'>{_emcVendor}</Text>
        default:
          return _emcVendor
      }
    }
  },
  {
    label: 'Fab Vendor',
    orderBy: 'fabVendor',
    render: ({ fabVendor }) => {
      const _fabVendor = fabVendor || 'Not Yet Determined'
      switch (_fabVendor) {
        case 'Not Required':
          return <Text color='green'>{_fabVendor}</Text>
        case 'Not Yet Determined':
          return <Text color='red'>{_fabVendor}</Text>
        default:
          return _fabVendor
      }
    }
  },
  {
    label: 'installer',
    orderBy: 'installer',
    render: ({ installer }) => {
      const _installer = installer || 'Not Yet Determined'
      switch (_installer) {
        case 'Not Required':
          return <Text color='green'>{_installer}</Text>
        case 'Not Yet Determined':
          return <Text color='red'>{_installer}</Text>
        default:
          return _installer
      }
    }
  },
  {
    label: 'Steel Vendor',
    orderBy: 'steelVendor',
    render: ({ steelVendor }) => {
      const _steelVendor = steelVendor || 'Not Yet Determined'
      switch (_steelVendor) {
        case 'Not Required':
          return <Text color='green'>{_steelVendor}</Text>
        case 'Not Yet Determined':
          return <Text color='red'>{_steelVendor}</Text>
        default:
          return _steelVendor
      }
    }
  },
  // {
  //   label: 'Job Packet',
  //   orderBy: 'fabRend',
  //   render: ({ fabRend }) => fabRend
  // },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const SHIPPING_PROJECTS_FILTER_FIELDS = ['cratingStatus', 'accountingApproval']
export const SHIPPING_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Crating Status',
    orderBy: 'cratingStatus',
    render: ({ cratingStatus }) => {
      const _cratingStatus = cratingStatus || PROJECT_CRATING_STATUS.Pending
      switch (_cratingStatus) {
        case PROJECT_CRATING_STATUS.Pending:
          return <Text color="red">{_cratingStatus}</Text>
        case PROJECT_CRATING_STATUS.Complete:
          return <Text color="green">{_cratingStatus}</Text>
        default:
          return _cratingStatus
      }
    }
  },
  {
    label: 'Accounting Approval',
    orderBy: 'accountingApproval',
    render: ({ accountingApproval }) => {
      const _accountingApproval = accountingApproval || PROJECT_ACCOUNTING_APPROVAL.Pending
      switch (_accountingApproval) {
        case PROJECT_ACCOUNTING_APPROVAL.Pending:
          return <Text color="red">{_accountingApproval}</Text>
        case PROJECT_ACCOUNTING_APPROVAL.Approved:
          return <Text color="green">{_accountingApproval}</Text>
        default:
          return _accountingApproval
      }
    }
  },
  {
    label: 'Combined EMC/Fab Carrier ETA',
    orderBy: 'combinedEMCFabCarrier',
    render: ({ combinedEMCFabCarrier }) => combinedEMCFabCarrier ?? <Text color="red">To be determined</Text>
  },
  {
    label: 'Combined EMC/Fab ETA',
    orderBy: 'combinedEMCFabEta',
    render: ({ combinedEMCFabEta }) => {
      const date = new Date(combinedEMCFabEta)
      return combinedEMCFabEta ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : <Text color="red">To be determined</Text>
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const INSTALL_PROJECTS_FILTER_FIELDS = []
export const INSTALL_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Target Date',
    orderBy: 'installDate',
    render: ({ installDate }) => {
      const date = new Date(installDate)
      return installDate ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : <Text color="red">Not Yet Determined</Text>
    }
  },
  {
    label: 'Days in Install',
    orderBy: 'daysInInstall',
    render: ({ daysInInstall }) => daysInInstall
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const POST_INSTALL_PROJECTS_FILTER_FIELDS = ['postInstallCall']
export const POST_INSTALL_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Post Install Call',
    orderBy: 'postInstallCall',
    render: ({ postInstallCall }) => {
      switch (postInstallCall) {
        case PROJECT_POST_INSTALL_CALL.Completed:
          return <Text color='green'>{postInstallCall}</Text>
        case PROJECT_POST_INSTALL_CALL.Incomplete:
          return <Text color='red'>{postInstallCall}</Text>
        default:
          return postInstallCall
      }
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const INVOICING_PROJECTS_FILTER_FIELDS = ['invoiceStatus']
export const INVOICING_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Invoice Status',
    orderBy: 'invoiceStatus',
    render: ({ invoiceStatus }) => {
      switch (invoiceStatus) {
        case PROJECT_INVOICE_STATUS.InvoiceSent:
          return <Text color='green'>{invoiceStatus}</Text>
        case PROJECT_INVOICE_STATUS.Incomplete:
          return <Text color='red'>{invoiceStatus}</Text>
        default:
          return invoiceStatus
      }
    }
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const MARGIN_REVIEW_PROJECTS_FILTER_FIELDS = []
export const MARGIN_REVIEW_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const COMPLETE_PROJECTS_FILTER_FIELDS = []
export const COMPLETE_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Customer Name',
    orderBy: 'customerName',
    render: ({ customerName }) => customerName
  },
  {
    label: 'Email',
    orderBy: 'customerEmail',
    render: ({ customerEmail }) => customerEmail
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const CANCELLED_PROJECTS_FILTER_FIELDS = []
export const CANCELLED_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Customer Name',
    orderBy: 'customerName',
    render: ({ customerName }) => customerName
  },
  {
    label: 'Email',
    orderBy: 'customerEmail',
    render: ({ customerEmail }) => customerEmail
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]

export const ON_HOLD_PROJECTS_FILTER_FIELDS = []
export const ON_HOLD_PROJECTS_COLUMNS = [
  {
    label: 'ID',
    orderBy: 'id',
    render: ({ id }) => id
  },
  {
    label: 'Company',
    orderBy: 'customerCompany',
    render: ({ customerCompany }) => customerCompany
  },
  {
    label: 'Order Date',
    orderBy: 'createdAt',
    render: ({ createdAt }) => {
      const date = new Date(createdAt)
      return createdAt ? formatDate(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy') : ''
    },
    toggleable: true
  },
  {
    label: 'State',
    orderBy: 'customerState',
    render: ({ customerState }) => customerState || '',
    toggleable: true
  },
  {
    label: 'Sales User',
    orderBy: 'salesUserName',
    render: ({ salesUserName }) => salesUserName || '',
    toggleable: true
  },
  {
    label: 'Customer Name',
    orderBy: 'customerName',
    render: ({ customerName }) => customerName
  },
  {
    label: 'Email',
    orderBy: 'customerEmail',
    render: ({ customerEmail }) => customerEmail
  },
  {
    label: 'View',
    render: ({ currentUser, notesCount, onRemove, onNotes, onView, ...rest }) => (
      <Flex columnGap={2}>
        <Button size="xs" colorScheme="gray" onClick={() => onNotes(rest)}>{`Notes (${notesCount})`}</Button>
        <Button size="xs" colorScheme="blue" onClick={() => onView(rest)}>View</Button>
        {currentUser?.role === ROLES.Admin && <Button size="xs" colorScheme="red" onClick={() => onRemove(rest)}>Remove</Button>}
      </Flex>
    )
  }
]
